import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const tiers = [
  { name: "Design Partner", price: "$0", period: "4 weeks", note: "Free pilot" },
  { name: "Team", price: "$390", period: "/mo", note: "≤25 engineers" },
  { name: "Business", price: "$1,490", period: "/mo", note: "25-100 engineers" },
  { name: "Enterprise", price: "$4,500+", period: "/mo", note: "100+ engineers, SOC 2" },
];

const PricingTeaser = () => (
  <section className="hidden section-padding" id="pricing-teaser">
    <div className="container-wide">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <p className="text-xs font-medium uppercase tracking-widest text-accent mb-3">
          Pricing
        </p>
        <h2 className="heading-lg mb-4">Free for 4 weeks. Then your team picks a tier.</h2>
        <p className="body-md text-muted-foreground">
          Pricing scales with engineers and repos, not seats. You&apos;re not penalized for adding readers.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto mb-10">
        {tiers.map((t) => (
          <div key={t.name} className="surface-card p-5 text-center">
            <p className="text-sm font-semibold mb-2">{t.name}</p>
            <div className="flex items-baseline justify-center gap-1 mb-2">
              <span className="text-2xl font-bold">{t.price}</span>
              <span className="text-xs text-muted-foreground">{t.period}</span>
            </div>
            <p className="text-xs text-muted-foreground">{t.note}</p>
          </div>
        ))}
      </div>

      <div className="text-center space-y-3">
        <Button variant="outline" asChild>
          <a href="/pricing">
            See full pricing
            <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
          </a>
        </Button>
        <p className="text-xs text-muted-foreground">
          YC alumni: 50% off Team for the first 12 months.
        </p>
      </div>
    </div>
  </section>
);

export default PricingTeaser;
